import request from './http';
// 获取banner
export const bannerList = (data) => {
  return request({
    url: '/banner/list',
    method: 'post',
    data: data,
  });
};
// 获取News&Events
export const NewsEventsList = (data) => {
  return request({
    url: '/news/list',
    method: 'post',
    data: data,
  });
};
// 获取News&Events 详情
export const NewsEventsDetail = (data) => {
  return request({
    url: '/news/detail',
    method: 'post',
    data: data,
  });
};
// 获取Support
export const supportList = (data) => {
  return request({
    url: '/support/list',
    method: 'post',
    data: data,
  });
};
// 获取Support 模糊搜索
export const searchSupport = (data) => {
  return request({
    url: '/support/search',
    method: 'post',
    data: data,
  });
};
// 获取产品首页
export const productHome = (data) => {
  return request({
    url: '/product/home',
    method: 'post',
    data: data,
  });
};
// 获取产品搜索
export const productSearch = (data) => {
  return request({
    url: '/product/search',
    method: 'post',
    data: data,
  });
};
// 登录
export const userLogin = (data) => {
  return request({
    url: '/user/login',
    method: 'post',
    data: data,
  });
};
// 注册
export const userRegister = (data) => {
  return request({
    url: '/user/register',
    method: 'post',
    data: data,
  });
};
// 忘记密码
export const resetPassSendEmail = (data) => {
  return request({
    url: '/user/resetPassSendEmail',
    method: 'post',
    data: data,
  });
};
// 重置密码
export const resetPassConfirm = (data) => {
  return request({
    url: '/user/resetPassConfirm',
    method: 'post',
    data: data,
  });
};
// 产品页左侧列表调用
export const productList = (data) => {
  return request({
    url: '/product/list',
    method: 'post',
    data: data,
  });
};
// 获取产品详情
export const productDetail = (data) => {
  return request({
    url: '/product/detail',
    method: 'post',
    data: data,
  });
};
// 购物车列表
export const cartList = (data) => {
  return request({
    url: '/cart/list',
    method: 'post',
    data: data,
  });
};
// 添加购物车
export const cartAdd = (data) => {
  return request({
    url: '/cart/add',
    method: 'post',
    data: data,
  });
};
// 产品界面添加购物车
export const addIncrement = (data) => {
  return request({
    url: '/cart/addIncrement',
    method: 'post',
    data: data,
  });
};
